import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { SeoService } from '../core/services/seo.service';
import { NavigationComponent } from '../shared/navigation.component';
import { FooterComponent } from '../shared/footer.component';

@Component({
  selector: 'app-terms-and-conditions',
  standalone: true,
  imports: [CommonModule, RouterModule, NavigationComponent, FooterComponent],
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {
  currentYear = new Date().getFullYear();
  lastUpdated = 'Abril 2026';

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.seoService.updateSEOData({
      keywords: 'términos y condiciones, condiciones de uso, acuerdo de servicio, SaaS chatbot, WhatsApp Business API, Pezeta Solutions',
      structuredData: {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Términos y Condiciones",
        "description": "Términos y condiciones de uso de Chatbot Pezeta, plataforma SaaS de chatbot con IA integrada a WhatsApp Business API. Pezeta Solutions.",
        "url": "https://chatbot.pezetasolutions.com/terminos-y-condiciones",
        "publisher": {
          "@type": "Organization",
          "name": "Pezeta Solutions",
          "logo": {
            "@type": "ImageObject",
            "url": "https://chatbot.pezetasolutions.com/images/gray-logo-80.webp"
          }
        },
        "dateModified": "2026-04-28",
        "inLanguage": "es-MX"
      }
    });

    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
  }
}
